import { useTranslation } from 'react-i18next'

import { AppHeader, AppParagraph } from 'client/ui-building-blocks'

const Stat = ({
  count,
  value,
  dictPath,
}: {
  count: number
  value: string
  dictPath: string
}) => {
  const { t } = useTranslation()

  return (
    <div>
      <AppHeader text={value} size="xxlarge" centered />
      <AppParagraph text={t(dictPath, { count })} centered />
    </div>
  )
}

export default Stat
